import React, {useState} from 'react';

import { ReactMultiEmail, isEmail } from 'react-multi-email';
import 'react-multi-email/style.css';
import ReactDOM from "react-dom";
import styled from 'styled-components'

export default function InviteFriendsInput() {
    const [emails, setEmails] = useState([])
    const [isCollapsed, setIsCollapsed] = useState(false)
    const [succeed, setSucceed] = useState(false)

    const sendInvitations = async () => {
        setSucceed(true)
        console.log(emails)
        await fetch(
            '/ajax/user/invite-others',
            {
                method: 'POST',
                body: JSON.stringify({ emails })
            }
        )
    }

    if(succeed) {
        return (

            <div> <GiftIcon src="/images/icons/tick.png" /> Hemos enviado tus invitaciones, te avisaremos cuando tus amigos se registren</div>
        )
    }
    return (
        <div>
            {!isCollapsed && (<ToCollapse onClick={() => setIsCollapsed(true)}>
                <GiftIcon src="/images/icons/gift.png" />
                Nuestra regla de 3: invita a 3 amigos y <High>te regalamos 3 semanas de suscripción</High></ToCollapse>)}

            {isCollapsed && (
                <div>

                    <CaptionForm>Cada 3 amigos que se registren en GaussOnline de tu parte te regalamos 3 semanas de suscripción. Sin trampa ni cartón:</CaptionForm>

                    <ReactMultiEmail
                        placeholder="Email de tu amigo"
                        emails={emails}
                        onChange={(_emails) => {
                            console.log(_emails)
                            setEmails(_emails)
                            // this.setState({ emails: _emails });
                        }}
                        validateEmail={email => {
                            return isEmail(email); // return boolean
                        }}
                        className="invite-friends-input"
                        getLabel={(
                            email,
                            index,
                            removeEmail
                        ) => {
                            return (
                                <div data-tag key={index}>
                                    {email}
                                    <span data-tag-handle onClick={() => removeEmail(index)}>
                      ×
                    </span>
                                </div>
                            );
                        }}
                    />

                    {emails.length > 0 ? (
                        <ButtonCaption>
                            <button className='button' onClick={sendInvitations}>Enviar invitaciones</button>
                        </ButtonCaption>
                    ) :
                        (
                            <InfoToDo>
                               Escribe el email de tus amigos separados por comas para conseguir
                            </InfoToDo>
                        )}

            </div>
            )}
        </div>

    )
}

const InfoToDo = styled.div`
  color: #303537;
  font-size: 18px;
  font-weight: bold;
`
const ToCollapse = styled.div`
  cursor: pointer;

`

const CaptionForm = styled.div`
  padding-bottom: 12px;
  font-size: 12px;
`

const ButtonCaption = styled.div`
  padding-top: 12px;
`

const LinkShare = styled.div`
  padding-top: 12px;
  font-size: 12px;
`

const High = styled.b`
  color: #303537;

`

const GiftIcon = styled.img`
  width: 20px;
  margin-right: 12px;
`



if (document.getElementsByTagName('invite-friends')) {
    const elements = document.getElementsByTagName('invite-friends')

    for(let element of elements) {
        ReactDOM.render(
            <InviteFriendsInput
            />, element);
    }

}
